export default {"src":"/_next/static/media/unionBackground.ee3af096.svg","height":242,"width":1440};